import React from 'react';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import 'moment/locale/es';
import { jsUcfirst } from '../utils/helpers.js';
import MejorComposicion from './MejorComposicion';

export default class MejorComp extends React.Component {
	render() {
		return (
			<div>
				<h2 className="empateTitulo">
					{this.props.ides.length > 1
						? `Mejor ${this.props.categoria} (empate)`
						: `Mejor ${this.props.categoria}`}
				</h2>
				{this.props.ides.map(x => (
					<MejorComposicion
						key={`${x}_mejores`}
						ides={x}
						mod={this.props.mod}
						agrupaciones={this.props.agrupaciones}
						fase={this.props.fase}
					/>
				))}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/MejorComp.js